import { Component, OnInit, Input, Output, ViewChild, TemplateRef, ComponentFactoryResolver, ViewContainerRef, EventEmitter } from '@angular/core';

import { CPQOptionRange, CPQScreenOption } from '../../../models/CPQUI';
import { ComponentFactoryService } from '../../../services/ComponentFactoryService';
import { RadioButtonComponent } from '../radio-button/radio-button.component';
import { SelectComponent } from '../select/select.component';
import { TextboxComponent } from '../textbox/textbox.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { NumberDropdownComponent } from '../number-dropdown/number-dropdown.component';
import { VertRadioButtonComponent } from '../vert-radio-button/vert-radio-button.component';

@Component({
  selector: 'app-cpqscreen-options',
  templateUrl: './cpqscreen-options.component.html',
  styleUrls: ['./cpqscreen-options.component.css']
})
export class CPQScreenOptionsComponent implements OnInit {
  @Output() handleValueChange: EventEmitter<CPQScreenOption> = new EventEmitter();
  @Output() handleInvalidEmitter: EventEmitter<any> = new EventEmitter();
  @Input() CurrentScreenOption: CPQScreenOption;
  @Input() Description: string;
  //@ViewChild('screenOptionTemplate', { read: TemplateRef }) screenOptionTemplate: TemplateRef<any>;
  constructor(public compFactory: ComponentFactoryResolver, public viewContainerRef: ViewContainerRef, private compFactoryService: ComponentFactoryService) { }

  ngOnInit(): void {

    if (this.CurrentScreenOption) {
      this.CurrentScreenOption.Caption = this.CurrentScreenOption.Caption.replace(/<\/?[^>]+(>|$)/g, "").replace(">>>", "");
      this.CurrentScreenOption.Description = this.CurrentScreenOption.Description ?? "";
      switch (this.CurrentScreenOption.DisplayType.toLowerCase()) {
        case "dropdown":
        case "typeabledropdown":
          const selectComponentRef = this.compFactoryService.createComponent(SelectComponent, this.viewContainerRef);
          selectComponentRef.instance.SetControl(this.CurrentScreenOption);
          selectComponentRef.instance.SelectOnChangeEmitter.subscribe(x => {
            this.handleValueChange.emit(x);
          });
          break;
        case "radiobuttonhorizontal":
          const radioComponentRef = this.compFactoryService.createComponent(RadioButtonComponent, this.viewContainerRef);
          radioComponentRef.instance.SetControl(this.CurrentScreenOption);
          radioComponentRef.instance.RadioOnChangeEmitter.subscribe(x => {
            this.handleValueChange.emit(x);
          });
          break;

        case "radiobuttonvertical":
          const vertRadioComponentRef = this.compFactoryService.createComponent(VertRadioButtonComponent, this.viewContainerRef);
          vertRadioComponentRef.instance.SetControl(this.CurrentScreenOption);
          vertRadioComponentRef.instance.RadioOnChangeEmitter.subscribe(x => {
            this.handleValueChange.emit(x);
          });
          break;
        case "numerictextbox":
          const numTextboxComponentRef = this.compFactoryService.createComponent(TextboxComponent, this.viewContainerRef);
          numTextboxComponentRef.instance.type = "number";
          //Find min/max from description
          if (this.Description && this.Description.length > 0) {
            var minRegEx = new RegExp(/Min\s+([\d.]+)\s?,/gi);
            var maxRegex = new RegExp(/Max\s+([\d.]+)\s?,/gi);

            var minMatch = minRegEx.exec(this.Description);
            var maxMatch = maxRegex.exec(this.Description);

            var minMaxRange = new CPQOptionRange();
            minMaxRange.Min = -100000;
            minMaxRange.Max = 100000;
            if (minMatch && minMatch.length > 0 && minMatch[1].length > 0) {
              minMaxRange.Min = parseFloat(minMatch[1]);
            }
            if (maxMatch && maxMatch.length > 0 && maxMatch[1].length > 0) {
              minMaxRange.Max = parseFloat(maxMatch[1]);
            }

            this.CurrentScreenOption.Ranges.push(minMaxRange);
          }
          numTextboxComponentRef.instance.SetControl(this.CurrentScreenOption);
          numTextboxComponentRef.instance.CheckInvalidEmitter.subscribe(x => {
            this.handleInvalidEmitter.emit(x);
          });
          numTextboxComponentRef.instance.OnBlurChangeEmitter.subscribe(x => {
            this.handleValueChange.emit(x);
          });
          break;
        case "textbox":
          const textboxComponentRef = this.compFactoryService.createComponent(TextboxComponent, this.viewContainerRef);
          textboxComponentRef.instance.type = "text";
          textboxComponentRef.instance.SetControl(this.CurrentScreenOption);
          textboxComponentRef.instance.OnBlurChangeEmitter.subscribe(x => {
            this.handleValueChange.emit(x);
          });
          break;
        case "checkbox":
          const checkBoxCompRef = this.compFactoryService.createComponent(CheckboxComponent, this.viewContainerRef);
          checkBoxCompRef.instance.SetControl(this.CurrentScreenOption);
          checkBoxCompRef.instance.OnCheckEmitter.subscribe(x => {
            this.handleValueChange.emit(x);
          });
          break;
        case "numericcontrol":
          const numSelectComponentRef = this.compFactoryService.createComponent(NumberDropdownComponent, this.viewContainerRef);
          numSelectComponentRef.instance.SetControl(this.CurrentScreenOption);
          numSelectComponentRef.instance.OnChangeEmitter.subscribe(x => {
            this.handleValueChange.emit(x);
          });
          break;
        default:
          break;
      }
    }
  }

}
